import { Injectable } from '@angular/core';
import {
  CompanyQPViewModelCompanyQPTotalTypePagedResultResponse,
  QualifiedPersonsClient
} from '@services/cleanfill-api/cleanfill-api.generated';
import { ISearchQuery } from '@view-models/interfaces/search-query';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpClientsService {
  constructor(private qualifiedPersonsClient: QualifiedPersonsClient) {}
  getClients(uniqueId: string, query: ISearchQuery): Observable<CompanyQPViewModelCompanyQPTotalTypePagedResultResponse> {
    return this.qualifiedPersonsClient.searchQPClients(
      uniqueId,
      query.Page,
      query.PageSize,
      query.SortBy,
      query.FilterBy,
      new Date().getTimezoneOffset().toString()
    );
  }
}
